
import NavBar from "../Nav/NavBar"

const Page404 = () => {
    return(
        <div>
            <NavBar/>
            Page not found
        </div>
    )
}

export default Page404;